<div class="quiz-generator-container" [ngClass]="{'bg-transparent':isDialog}">
    <p [ngClass]="{'text-center': isDialog}" class="mb-4 text-16-400-150 text-c4">{{'Choose category' | translate}}</p>
    <!-- category options -->
    <div class="grid-category">
        <div class="grid-category-item text-20-400-120 text-c4" 
        [ngClass]="{'focus-category':selectedCategroy == category.id}"
        *ngFor="let category of categoryList;let i = index"
        (click)="selectedCategroy = category.id" >
            <img width="32" height="32" [src]="category.image" alt="">
            {{category.name | translate}}
        </div>
    </div>
    <form [formGroup]="categoryForm" class="category-form text-center w-100" >
        <div class="my-4">
          <h5 class="mb-2 text-16-400-150 text-c4">{{'Number of Teams' | translate}}</h5>
          <div class="d-flex justify-content-between align-items-center">
            <button [ngClass]="{'opacity-h':!fControl.teams.value}" class="btn-counter" (click)="decrement(fControl.teams)">-</button>
            <input 
            min="0" 
            max="10" 
            appMaxTwoCharacters
            [ngClass]="{'focus-category':fControl.teams.value,'input-empty': !fControl.teams.value}" 
            formControlName="teams" 
            type="number">
            <button [ngClass]="{'opacity-h':fControl.teams.value >= maxLimitTeams}" class="btn-counter" (click)="increment(fControl.teams)">+</button>
          </div>
          <div *ngIf="fControl.teams.touched && fControl.teams?.errors" class="text-danger text-14-400-157 pt-2">
            {{'Min:1 & Max:10' | translate}}
          </div>
        </div>
        <div class="my-4">
          <h5 class="mb-2 text-16-400-150 text-c4">{{'Number of Questions' | translate}}</h5>
          <div class="d-flex justify-content-between align-items-center">
            <button [ngClass]="{'opacity-h':!fControl.questions.value}" class="btn-counter" (click)="decrement(fControl.questions)">-</button>
            <input 
            min="0" 
            max="12" 
            appMaxTwoCharacters
            [ngClass]="{'focus-category': fControl.questions.value,'input-empty': !fControl.questions.value}" 
            type="number" 
            formControlName="questions" 
            [value]="questions">
            <button [ngClass]="{'opacity-h':fControl.questions.value >= maxLimitQuestions}" class="btn-counter" (click)="increment(fControl.questions)">+</button>
          </div>
          <div *ngIf="fControl.questions.touched && fControl.questions?.errors" class="text-danger text-14-400-157 pt-2">
            {{'Min:1 & Max:12' | translate}}
          </div>
        </div>
        <button (click)="submitQuizConfig()"
        [ngClass]="{'disabled' : !selectedCategroy || this.categoryForm.invalid}"
        class="generate-btn mt-3 text-16-500-125">{{'Generate quiz' | translate}}</button>
        <!-- Number of Teams -->
        <!-- <div class="my-5">
          <h5 class="mb-2 text-16-400-150 text-c4">{{'Number of Teams' | translate}}</h5>
          <div class="d-flex justify-content-between align-items-center">
            <button [ngClass]="{'opacity-h':teams == 0}" class="btn-counter" (click)="decrement('teams')">-</button>
            <input [ngClass]="{'focus-category':teams > 0,'input-empty': teams == 0}" type="text" [value]="teams" value="0" readonly>
            <button [ngClass]="{'opacity-h':teams == maxLimitTeams}" class="btn-counter" (click)="increment('teams')">+</button>
          </div>
        </div> -->
        
        <!-- Number of Questions -->
        <!-- <div class="my-5">
          <h5 class="mb-2 text-16-400-150 text-c4">{{'Number of Questions' | translate}}</h5>
          <div class="d-flex justify-content-between align-items-center">
            <button [ngClass]="{'opacity-h':questions == 0}" class="btn-counter" (click)="decrement('questions')">-</button>
            <input [ngClass]="{'focus-category': questions > 0,'input-empty': questions == 0}" type="text" [value]="questions" value="0" readonly>
            <button [ngClass]="{'opacity-h':questions == maxLimitQuestions}" class="btn-counter" (click)="increment('questions')">+</button>
          </div>
        </div> -->
        <!-- Generate Quiz Button -->
        <!-- <button (click)="submitQuizConfig()"
        [ngClass]="{'disabled' : !questions || !teams || !selectedCategroy}"
        class="generate-btn text-16-500-125">{{'Generate Quiz' | translate}}</button>
      </div> -->
</form>
